'use strict';

angular.module('invitations')
    .controller('InvitationCodeFormController', ['$q', 'InvitationsManager', 'ShareCrfApiErrorCodes', 'gettext', function($q, InvitationsManager, ShareCrfApiErrorCodes, gettext) {
        var vm = this;

        vm.collapsed = true;
        vm.invitationCode = null;

        vm.toggleVisibility = function() {
            vm.collapsed = !vm.collapsed;
        };

        vm.submitted = false;
        vm.running = false;
        vm.error = false;
        vm.success = false;

        vm.submit = function(form) {
            vm.submitted = true;
            vm.error = false;
            vm.success = false;

            var promise;
            if (form.$valid) {
                vm.running = true;

                promise = InvitationsManager.assignInvitationCode(vm.invitationCode)
                    .then(function() {
                        vm.reset();
                        vm.success = true;
                    })
                    .catch(function(error) {
                        if (error.code && error.code === 'params-error') {
                            vm.error = gettext('El código de invitación enviado no es válido');
                        } else {
                            vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                        }
                        vm.running = false;
                    });
            } else {
                promise = $q.resolve();
            }

            return promise;
        };

        vm.reset = function() {
            vm.invitationCode = null;
            vm.collapsed = true;
            vm.submitted = false;
            vm.running = false;
            vm.error = false;
            vm.success = false;
        };
    }]);
